import React, { useState, useEffect } from 'react';
import { authService } from '../../api';
import { useNavigate, useParams, Link } from 'react-router-dom';
import './Connexion.css';

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    password: '',
    password_confirmation: ''
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const { token } = useParams();

  // Dans une app réelle, vous devriez extraire l'email du lien ou demander à l'utilisateur
  const [email, setEmail] = useState('');

  useEffect(() => {
    // Extraire l'email de l'URL si présent
    const urlParams = new URLSearchParams(window.location.search);
    const emailFromUrl = urlParams.get('email');
    if (emailFromUrl) {
      setEmail(emailFromUrl);
    }
  }, []);

  const validateForm = () => {
    const newErrors = {};
    
    if (!email) {
      newErrors.email = 'Email requis';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Email invalide';
    }

    if (!formData.password) {
      newErrors.password = 'Mot de passe requis';
    } else if (formData.password.length < 8) {
      newErrors.password = 'Minimum 8 caractères';
    }

    if (!formData.password_confirmation) {
      newErrors.password_confirmation = 'Confirmation requise';
    } else if (formData.password !== formData.password_confirmation) {
      newErrors.password_confirmation = 'Les mots de passe ne correspondent pas';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const response = await authService.resetPassword(
        token,
        email,
        formData.password,
        formData.password_confirmation
      );

      if (response.success) {
        setSuccess(response.message || 'Mot de passe réinitialisé avec succès !');
        setTimeout(() => {
          navigate('/connexion');
        }, 3000);
      } else {
        setError(response.message || 'Échec de la réinitialisation');
      }
    } catch (err) {
      setError(err.message || 'Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <Link to="/" className="home-arrow">
        <div className="arrow-icon">←</div>
      </Link>
      <div className="login-card">
        <h2 className="login-title">Nouveau mot de passe</h2>

        {error && <div className="login-error">{error}</div>}
        {success && <div className="login-success">{success}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className={`input-field ${errors.email ? 'has-error' : ''}`}>
            <label className="input-label">Email *</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
            />
            {errors.email && <span className="field-error">{errors.email}</span>}
          </div>

          <div className={`input-field ${errors.password ? 'has-error' : ''}`}>
            <label className="input-label">Nouveau mot de passe *</label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                className="login-input password-input"
                required
              />
              <button 
                type="button" 
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {errors.password && <span className="field-error">{errors.password}</span>}
          </div>

          <div className={`input-field ${errors.password_confirmation ? 'has-error' : ''}`}>
            <label className="input-label">Confirmer le mot de passe *</label>
            <div className="password-input-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={formData.password_confirmation}
                onChange={(e) => setFormData({...formData, password_confirmation: e.target.value})}
                className="login-input password-input"
                required
              />
              <button 
                type="button" 
                className="password-toggle"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {errors.password_confirmation && (
              <span className="field-error">{errors.password_confirmation}</span>
            )}
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
          </button>
        </form>

        <div className="login-footer">
          <p>
            <button 
              className="login-linkbtn"
              onClick={() => navigate('/connexion')}
            >
              ← Retour à la connexion
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;